export enum EditorPluginType {
  Anchor = 'anchor',
  Article = 'article',
  Audio = 'audio',
  ArticleIntroduction = 'articleIntroduction',
  Box = 'box',
  Course = 'course',
  Equations = 'equations',
  Geogebra = 'geogebra',
  H5p = 'h5p',
  Highlight = 'highlight',
  Image = 'image',
  ImageGallery = 'imageGallery',
  InteractiveVideo = 'interactiveVideo',
  Injection = 'injection',
  Multimedia = 'multimedia',

  PageLayout = 'pageLayout',
  PasteHack = 'pasteHack',

  Rows = 'rows',
  SerloTable = 'serloTable',
  Spoiler = 'spoiler',

  Text = 'text',
  Video = 'video',

  DropzoneImage = 'dropzoneImage',
  ExerciseGroup = 'exerciseGroup',
  Exercise = 'exercise',
  ScMcExercise = 'scMcExercise',
  InputExercise = 'inputExercise',
  TextAreaExercise = 'textAreaExercise',
  BlanksExercise = 'blanksExercise',
  Solution = 'solution',

  SerloInjection = 'serloInjection',
  EdusharingAsset = 'edusharingAsset',

  Unsupported = 'unsupported',
}
